import * as React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Extractors } from "@graylog/server-api";
import { Spinner } from "components/common";
import { Table } from "components/bootstrap";
import { defaultOnError } from "util/conditional/onError";
import i18n from "i18n";
const fetchExtractors = (inputId) => Extractors.list(inputId);
const useInputExtractors = (inputId) => useQuery({
  queryKey: ["input", inputId, "extractors"],
  queryFn: () => defaultOnError(
    fetchExtractors(inputId),
    i18n.t("overview.sections.load_extractors_failed", { ns: "inputs" }),
    i18n.t("overview.sections.could_not_load_extractors_title", { ns: "inputs" })
  )
});
const ExtractorsSection = ({ input }) => {
  var _a;
  const { t } = useTranslation("inputs");
  const { data, isInitialLoading, isError } = useInputExtractors(input.id);
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("p", null, t("overview.sections.could_not_load_extractors"));
  }
  const extractors = (_a = data == null ? void 0 : data.extractors) != null ? _a : [];
  if (extractors.length === 0) {
    return /* @__PURE__ */ React.createElement("p", null, t("overview.sections.no_extractors"));
  }
  return /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("overview.sections.extractor_title")), /* @__PURE__ */ React.createElement("th", null, t("overview.sections.extractor_type")), /* @__PURE__ */ React.createElement("th", null, t("overview.sections.source_field")), /* @__PURE__ */ React.createElement("th", null, t("overview.sections.target_field")))), /* @__PURE__ */ React.createElement("tbody", null, extractors.map((extractor) => /* @__PURE__ */ React.createElement("tr", { key: extractor.id }, /* @__PURE__ */ React.createElement("td", null, extractor.title), /* @__PURE__ */ React.createElement("td", null, extractor.type), /* @__PURE__ */ React.createElement("td", null, extractor.source_field), /* @__PURE__ */ React.createElement("td", null, extractor.target_field)))));
};
export default ExtractorsSection;
